import React, {
  createContext,
  useContext,
  useState,
  type ReactNode,
} from 'react';

interface TestUsersContextType {
  includeTestUsers: boolean;
  setIncludeTestUsers: (value: boolean) => void;
}

const TestUsersContext = createContext<TestUsersContextType | undefined>(
  undefined,
);

export const TestUsersProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [includeTestUsers, setIncludeTestUsers] = useState<boolean>(false);

  return (
    <TestUsersContext.Provider
      value={{ includeTestUsers, setIncludeTestUsers }}
    >
      {children}
    </TestUsersContext.Provider>
  );
};

export const useTestUsers = (): TestUsersContextType => {
  const context = useContext(TestUsersContext);
  if (context === undefined) {
    throw new Error('useTestUsers must be used within a TestUsersProvider');
  }
  return context;
};
